module.exports = __webpack_public_path__ + "img/13.dc48ad68.png";